import {
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";

const HelpModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent borderRadius="12px">
        <ModalCloseButton />
        <ModalBody py={6}>
          <VStack w="full" align="flex-start" spacing={6}>
            <Text fontSize="lg" fontWeight="500">
              Access Reviews
            </Text>
            <VStack w="full" align="flex-start" spacing={1}>
              <Text fontSize="sm" fontWeight="500" color="gray.600">
                What are access reviews?
              </Text>
              <Divider />
              <Text fontSize="sm" fontWeight="400" color="gray.600">
                Access reviews are a process that companies undertake to ensure
                the <b>right</b> people have access to the <b>right</b>{" "}
                applications. You've been assigned to complete one by your IT or
                security team because they believe that you are in a position to
                decide who needs access to one or more applications.
              </Text>
              <Text fontSize="sm" fontWeight="400" color="gray.600" pt={2}>
                On this page, you'll find a list of all the apps you've been
                assigned to complete an access review for. For each application
                you need to look at each person in the list who has an account
                and decide whether or not they still need access to the
                application.
              </Text>
              <Text fontSize="sm" fontWeight="400" color="gray.600" pt={2}>
                For each person, choose a decision with the buttons on their
                row. Your IT or security team sets which decisions each review
                offers. Some decisions open a dialog where you add a reason
                before the decision is saved. If you have any questions, it's
                best to reach out to your IT or security team for more details.
              </Text>
              <Text fontSize="sm" fontWeight="400" color="gray.600" pt={2}>
                Once you have decided on every account, press Submit decisions.
                Your IT or security team is then notified and can approve the
                review.
              </Text>
            </VStack>
            <VStack w="full" align="flex-start" spacing={1}>
              <Text fontSize="sm" fontWeight="500" color="gray.600">
                What is Ploy?
              </Text>
              <Divider />
              <Text fontSize="sm" fontWeight="400" color="gray.600">
                Ploy is a SaaS management and security platform. We help
                companies like yours, protect and manage their SaaS
                applications. You can ask your IT or security team for more
                information.
              </Text>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default HelpModal;
